import React from 'react';

import Scoreboard from '@/components/scoreboard/Scoreboard';

interface ScoreInputModalProps {
  isEdit: boolean;
  propsTeam1: string | undefined;
  propsTeam2: string | undefined;
  propsTeam1FirstHalfScore: number | undefined;
  propsTeam2FirstHalfScore: number | undefined;
  propsTeam1SecondHalfScore: number | undefined;
  propsTeam2SecondHalfScore: number | undefined;
  propsTeam1ExtraFirstHalfScore: number | undefined;
  propsTeam2ExtraFirstHalfScore: number | undefined;
  propsTeam1ExtraSecondHalfScore: number | undefined;
  propsTeam2ExtraSecondHalfScore: number | undefined;
  propsTeam1PKScore: number | undefined;
  propsTeam2PKScore: number | undefined;
  onInputTeam1?: (value: string) => void;
  onInputTeam2: (value: string) => void;
  onChangeTeam1FirstHalfScore: (value: number | undefined) => void;
  onChangeTeam2FirstHalfScore: (value: number | undefined) => void;
  onChangeTeam1SecondHalfScore: (value: number | undefined) => void;
  onChangeTeam2SecondHalfScore: (value: number | undefined) => void;
  onChangeTeam1ExFirstScore: (value: number | undefined) => void;
  onChangeTeam2ExFirstScore: (value: number | undefined) => void;
  onChangeTeam1ExSecondScore: (value: number | undefined) => void;
  onChangeTeam2ExSecondScore: (value: number | undefined) => void;
  onChangeTeam1PKScore: (value: number | undefined) => void;
  onChangeTeam2PKScore: (value: number | undefined) => void;
  closeModal: () => void;
}

/**
 * スコア入力モーダル
 * @param param0
 * @returns
 */
const ScoreInputModal: React.FC<ScoreInputModalProps> = ({
  isEdit,
  propsTeam1,
  propsTeam2,
  propsTeam1FirstHalfScore,
  propsTeam2FirstHalfScore,
  propsTeam1SecondHalfScore,
  propsTeam2SecondHalfScore,
  propsTeam1ExtraFirstHalfScore,
  propsTeam2ExtraFirstHalfScore,
  propsTeam1ExtraSecondHalfScore,
  propsTeam2ExtraSecondHalfScore,
  propsTeam1PKScore,
  propsTeam2PKScore,
  onInputTeam1,
  onInputTeam2,
  onChangeTeam1FirstHalfScore,
  onChangeTeam2FirstHalfScore,
  onChangeTeam1SecondHalfScore,
  onChangeTeam2SecondHalfScore,
  onChangeTeam1ExFirstScore,
  onChangeTeam2ExFirstScore,
  onChangeTeam1ExSecondScore,
  onChangeTeam2ExSecondScore,
  onChangeTeam1PKScore,
  onChangeTeam2PKScore,
  closeModal
}) => {
  /**
   *
   */
  const handleModalClick = (e: React.MouseEvent<HTMLDivElement>) => {
    // モーダルの背景をクリックした場合にだけ closeModal を呼び出す
    const modalBackground = document.getElementById('modal-background');
    if (e.target === modalBackground) {
      closeModal();
    }
  };

  return (
    <>
      <div
        tabIndex={-1}
        onClick={handleModalClick}
        id="modal-background"
        aria-hidden="true"
        className="fixed inset-0 z-30 w-full flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
        <div className="fixed z-50 top-0 right-0 flex items-center justify-between p-2">
          <button
            type="button"
            className="text-gray-300 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
            data-modal-hide="tacticalboard-modal"
            onClick={closeModal}>
            <svg
              className="w-6 h-6"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14">
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
            <span className="sr-only">Close modal</span>
          </button>
        </div>
        <div className="w-11/12 lg:w-6/12 bg-white rounded-lg">
          <Scoreboard
            isEdit={isEdit}
            propsScoreboardValues={{
              valTeam1: propsTeam1,
              valTeam2: propsTeam2,
              valTeam1FirstHalfScore: propsTeam1FirstHalfScore,
              valTeam2FirstHalfScore: propsTeam2FirstHalfScore,
              valTeam1SecondHalfScore: propsTeam1SecondHalfScore,
              valTeam2SecondHalfScore: propsTeam2SecondHalfScore,
              valTeam1ExtraFirstHalfScore: propsTeam1ExtraFirstHalfScore,
              valTeam2ExtraFirstHalfScore: propsTeam2ExtraFirstHalfScore,
              valTeam1ExtraSecondHalfScore: propsTeam1ExtraSecondHalfScore,
              valTeam2ExtraSecondHalfScore: propsTeam2ExtraSecondHalfScore,
              valTeam1PKScore: propsTeam1PKScore,
              valTeam2PKScore: propsTeam2PKScore
            }}
            onInputTeam1={onInputTeam1}
            onInputTeam2={onInputTeam2}
            onChangeTeam1FirstHalfScore={onChangeTeam1FirstHalfScore}
            onChangeTeam2FirstHalfScore={onChangeTeam2FirstHalfScore}
            onChangeTeam1SecondHalfScore={onChangeTeam1SecondHalfScore}
            onChangeTeam2SecondHalfScore={onChangeTeam2SecondHalfScore}
            onChangeTeam1ExFirstScore={onChangeTeam1ExFirstScore}
            onChangeTeam2ExFirstScore={onChangeTeam2ExFirstScore}
            onChangeTeam1ExSecondScore={onChangeTeam1ExSecondScore}
            onChangeTeam2ExSecondScore={onChangeTeam2ExSecondScore}
            onChangeTeam1PKScore={onChangeTeam1PKScore}
            onChangeTeam2PKScore={onChangeTeam2PKScore}
          />
        </div>
      </div>
    </>
  );
};

export default ScoreInputModal;
